import {IOrcamento} from "../types/IOrcamento";

export const CriaOrcamentoAposTotalizador = (orcamentoRedux: IOrcamento, orcamentoLegado: IOrcamento, orcamentoAtualizado: IOrcamento):{orcamentoReact: IOrcamento, orcamentoLegado: IOrcamento} => {

    const novoOrcamentoReact: IOrcamento = {
        ...orcamentoRedux,
        ParcelasFormaPagamento: orcamentoAtualizado.ParcelasFormaPagamento,
        DescontoAcumulado: orcamentoAtualizado.DescontoAcumulado,
        ItensOrcamento: orcamentoAtualizado.ItensOrcamento,
        PercentualDesconto: orcamentoAtualizado.PercentualDesconto,
        PercentualDescontoAcumulado:  orcamentoAtualizado.PercentualDescontoAcumulado,
        PercentualSeguroEntrega:  orcamentoAtualizado.PercentualSeguroEntrega,
        SubTotal:  orcamentoAtualizado.SubTotal,
        ValorAcrescimoFinanceiro: orcamentoAtualizado.ValorAcrescimoFinanceiro,
        ValorDesconto: orcamentoAtualizado.ValorDesconto,
        ValorDespesasInclusas: orcamentoAtualizado.ValorDespesasInclusas,
        ValorFrete: orcamentoAtualizado.ValorFrete,
        ValorServicoAdicionalDespesa: orcamentoAtualizado.ValorServicoAdicionalDespesa,
        ValorIPI: orcamentoAtualizado.ValorIPI,
        ValorSeguroEntrega: orcamentoAtualizado.ValorSeguroEntrega,
        ValorSubstituicao: orcamentoAtualizado.ValorSubstituicao,
        ValorTotal: orcamentoAtualizado.ValorTotal,
        ValorTotalSolicitado: orcamentoAtualizado.ValorTotalSolicitado,
        ValorTotalPendente: orcamentoAtualizado.ValorTotalPendente,
        ValorDescontoIcms: orcamentoAtualizado.ValorDescontoIcms,
        ValorTotalMercadorias: orcamentoAtualizado.ValorTotalMercadorias,
        ValorTotalMercadoriasNacionais: orcamentoAtualizado.ValorTotalMercadoriasNacionais,
        ValorTotalMercadoriasImportadas: orcamentoAtualizado.ValorTotalMercadoriasImportadas,
        PercentualDescontoSobreMercadoriasNacionais: orcamentoAtualizado.PercentualDescontoSobreMercadoriasNacionais,
        PercentualDescontoSobreMercadoriasImportadas: orcamentoAtualizado.PercentualDescontoSobreMercadoriasImportadas,
        ValorDescontoSobreMercadoriasNacionais: orcamentoAtualizado.ValorDescontoSobreMercadoriasNacionais,
        ValorDescontoSobreMercadoriasImportadas: orcamentoAtualizado.ValorDescontoSobreMercadoriasImportadas,
        TipoTratamentoDesconto: orcamentoAtualizado.TipoTratamentoDesconto,
        PerdaCotacao: orcamentoAtualizado.PerdaCotacao,
        PercentualDescontoPadraoCliente: orcamentoAtualizado.PercentualDescontoPadraoCliente,
        OidFornecedorPorRepresentacao: orcamentoAtualizado.OidFornecedorPorRepresentacao, // 456252
        ManterReserva: orcamentoAtualizado.ManterReserva,
        UserMessage: orcamentoAtualizado.UserMessage,

        LimiteCreditoCliente: orcamentoAtualizado.LimiteCreditoCliente, // 448734
        LimiteCreditoClienteBloqueado: orcamentoAtualizado.LimiteCreditoClienteBloqueado, // 448734
        LimiteCreditoClientePendenciaFinanceira: orcamentoAtualizado.LimiteCreditoClientePendenciaFinanceira, // 448734

        AtivarRecebimentoPixAPrazo: orcamentoAtualizado.AtivarRecebimentoPixAPrazo, // 414608
        ElegivelParaEmailCobrancaPixPrazo: orcamentoAtualizado.ElegivelParaEmailCobrancaPixPrazo, // 414608

        SaldoCashbackCliente: orcamentoAtualizado.SaldoCashbackCliente, // 438892
        ValidadeCashbackCliente: orcamentoAtualizado.ValidadeCashbackCliente,
        ValorCashbackUtilizado: orcamentoAtualizado.ValorCashbackUtilizado,
        AplicaDescontoCashback: orcamentoAtualizado.AplicaDescontoCashback,
    }

    const novoOrcamentoLegado = {
        ...orcamentoLegado,
        ParcelasFormaPagamento: orcamentoAtualizado.ParcelasFormaPagamento,
        DescontoAcumulado: orcamentoAtualizado.DescontoAcumulado,
        ItensOrcamento: orcamentoAtualizado.ItensOrcamento,
        PercentualDesconto: orcamentoAtualizado.PercentualDesconto,
        PercentualDescontoAcumulado:  orcamentoAtualizado.PercentualDescontoAcumulado,
        PercentualSeguroEntrega:  orcamentoAtualizado.PercentualSeguroEntrega,
        SubTotal:  orcamentoAtualizado.SubTotal,
        ValorAcrescimoFinanceiro: orcamentoAtualizado.ValorAcrescimoFinanceiro,
        ValorDesconto: orcamentoAtualizado.ValorDesconto,
        ValorDespesasInclusas: orcamentoAtualizado.ValorDespesasInclusas,
        ValorFrete: orcamentoAtualizado.ValorFrete,
        ValorServicoAdicionalDespesa: orcamentoAtualizado.ValorServicoAdicionalDespesa,
        ValorIPI: orcamentoAtualizado.ValorIPI,
        ValorSeguroEntrega: orcamentoAtualizado.ValorSeguroEntrega,
        ValorSubstituicao: orcamentoAtualizado.ValorSubstituicao,
        ValorTotal: orcamentoAtualizado.ValorTotal,
        ValorTotalSolicitado: orcamentoAtualizado.ValorTotalSolicitado,
        ValorTotalPendente: orcamentoAtualizado.ValorTotalPendente,
        ValorDescontoIcms: orcamentoAtualizado.ValorDescontoIcms,
        ValorTotalMercadorias: orcamentoAtualizado.ValorTotalMercadorias,
        ValorTotalMercadoriasNacionais: orcamentoAtualizado.ValorTotalMercadoriasNacionais,
        ValorTotalMercadoriasImportadas: orcamentoAtualizado.ValorTotalMercadoriasImportadas,
        PercentualDescontoSobreMercadoriasNacionais: orcamentoAtualizado.PercentualDescontoSobreMercadoriasNacionais,
        PercentualDescontoSobreMercadoriasImportadas: orcamentoAtualizado.PercentualDescontoSobreMercadoriasImportadas,
        ValorDescontoSobreMercadoriasNacionais: orcamentoAtualizado.ValorDescontoSobreMercadoriasNacionais,
        ValorDescontoSobreMercadoriasImportadas: orcamentoAtualizado.ValorDescontoSobreMercadoriasImportadas,
        TipoTratamentoDesconto: orcamentoAtualizado.TipoTratamentoDesconto,
        PerdaCotacao: orcamentoAtualizado.PerdaCotacao,
        UserMessage: orcamentoAtualizado.UserMessage,

        OidFornecedorPorRepresentacao: orcamentoAtualizado.OidFornecedorPorRepresentacao, // 456252
        ManterReserva: orcamentoAtualizado.ManterReserva,

        AtivarRecebimentoPixAPrazo: orcamentoAtualizado.AtivarRecebimentoPixAPrazo, // 414608
        ElegivelParaEmailCobrancaPixPrazo: orcamentoAtualizado.ElegivelParaEmailCobrancaPixPrazo, // 414608

        SaldoCashbackCliente: orcamentoAtualizado.SaldoCashbackCliente, // 438892
        ValidadeCashbackCliente: orcamentoAtualizado.ValidadeCashbackCliente,
        ValorCashbackUtilizado: orcamentoAtualizado.ValorCashbackUtilizado,
        AplicaDescontoCashback: orcamentoAtualizado.AplicaDescontoCashback,

        
    }

    return {
        orcamentoReact: novoOrcamentoReact,
        orcamentoLegado: novoOrcamentoLegado
    }
}
